import { ref } from 'vue'
export const scanRevision = ref(0)
/** Scan proof stays in this tab, never in query strings, logs or login redirect URLs. */
export interface ScanTicket { activity_id: number; slot_id?: number; qr_ticket: string; captured_at: number }
const KEY = 'cqu:scan-ticket'
let memory: ScanTicket | null = null
export function captureScanTicket(hash: string) {
  clearScanTicket()
  scanRevision.value++
  const params = new URLSearchParams(hash.replace(/^#/, ''))
  const aid = params.get('activity') || '', sid = params.get('slot') || '', proof = params.get('ticket') || ''
  if (!/^[1-9]\d{0,9}$/.test(aid) || (sid && !/^[1-9]\d{0,9}$/.test(sid)) || !/^[A-Za-z0-9_-]{43}$/.test(proof)) return
  memory = { activity_id: Number(aid), slot_id: sid ? Number(sid) : undefined, qr_ticket: proof, captured_at: Date.now() }
  try { sessionStorage.setItem(KEY, JSON.stringify(memory)) } catch { /* Current-tab memory still supports the login flow. */ }
}
export function readScanTicket(): ScanTicket | null {
  if (!memory) { try { memory = JSON.parse(sessionStorage.getItem(KEY) || 'null') } catch {} }
  if (!memory || !Number.isSafeInteger(memory.activity_id) || !/^[A-Za-z0-9_-]{43}$/.test(memory.qr_ticket) || Date.now() - memory.captured_at > 15 * 60000) { clearScanTicket(); return null }
  return memory
}
export function clearScanTicket() { memory = null; try { sessionStorage.removeItem(KEY) } catch {} }
export function checkInQRUrl(origin: string, issued: { activity_id: number; slot_id: number | null; qr_ticket: string }): string {
  const url = new URL('/check-in', origin)
  const params = new URLSearchParams({ activity: String(issued.activity_id), ticket: issued.qr_ticket })
  if (issued.slot_id) params.set('slot', String(issued.slot_id))
  url.hash = params.toString()
  return url.href
}
